import { render, staticRenderFns } from "./HelpMyAccount.vue?vue&type=template&id=756b8179&scoped=true"
import script from "./HelpMyAccount.vue?vue&type=script&lang=js"
export * from "./HelpMyAccount.vue?vue&type=script&lang=js"
import style0 from "./HelpMyAccount.vue?vue&type=style&index=0&id=756b8179&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756b8179",
  null
  
)

export default component.exports